export const INPUT_STYLES = {
  error: 'error',
  warning: 'warning',
  success: 'success',
  info: 'info'
}
 